'use client';
import { useState } from 'react';
// import {
//   SliderInput,
//   SliderTrack,
//   SliderRange,
//   SliderHandle,
// } from '@reach/slider';

export interface RangeInputProps {
  label: string;
  min: number;
  max: number;
  value?: number;

  onChange(newValue: number): void;
}

export function RangeInput({
  label,
  min,
  max,
  value,
  onChange,
}: RangeInputProps) {
  const [currentValue, setValue] = useState(value || 0);

  const handleChange = (newValue: number) => {
    setValue(newValue);
    onChange(newValue);
  };

  return (
    <div>
      <label>{label || 'Range input'}</label>
      {/* <SliderInput
        min={min}
        max={max}
        value={currentValue}
        className="w-full h-2 rounded-md"
        onChange={handleChange}
      >
        <SliderTrack className="h-full bg-primary-lighten-40 rounded-md">
          <SliderRange className=" h-full rounded-md bg-text-primary z-10" />
          <SliderHandle className="bg-primary-lighten-60 h-6 w-6 border-text-primary border-2 -mt-2 rounded-full z-20" />
        </SliderTrack>
      </SliderInput> */}
    </div>
  );
}

export default RangeInput;
